import { FC, useState } from 'react';
import { Dashboard, LastSyncBanner } from '../components/access';
import { ActiveDirectoryAccessProvider } from '../context';
import { ActiveDirectoryAccessTab, ActiveDirectoryAccessTabs } from '../common';
import { Alert, Tabs } from '@silverfort/sf-components';
import { ApplicationsView } from '../components/access/applications';
import { ResourcesView } from '../components/access/resources/ResourcesView';

export const ActiveDirectoryAccessPage: FC = () => {
    const [selectedTab, setSelectedTab] = useState(ActiveDirectoryAccessTab.Applications);

    return (
        <article className="h-[calc(100%-4rem)] w-[calc(100%-4rem)] bg-sf-white mt-16 ml-16">
            <LastSyncBanner />

            <div className="flex flex-col gap-4 p-6 h-full">
                <ActiveDirectoryAccessProvider>
                    <Dashboard />

                    <Tabs onClick={setSelectedTab} selectedTab={selectedTab} tabs={ActiveDirectoryAccessTabs} />

                    {selectedTab === ActiveDirectoryAccessTab.Applications && <ApplicationsView />}
                    {selectedTab === ActiveDirectoryAccessTab.Resources && <ResourcesView />}
                </ActiveDirectoryAccessProvider>
            </div>

            <Alert />
        </article>
    );
};
